import { z } from "zod";
import { type Role, RoleSchema } from "./enums.js";

/**
 * User read DTO for the admin console. Deliberately omits `passwordHash` — it is
 * never serialized; the UI only learns *whether* a password is set (`hasPassword`).
 */
export const UserDtoSchema = z.object({
  id: z.uuid(),
  email: z.string(),
  name: z.string().nullable(),
  role: RoleSchema,
  isActive: z.boolean(),
  hasPassword: z.boolean(),
  createdAt: z.string(),
});
export type UserDto = z.infer<typeof UserDtoSchema>;

export const UserCreateSchema = z.object({
  email: z.string().email(),
  name: z.string().min(1).nullish(),
  role: RoleSchema.default("client_viewer"),
  // Optional now — magic-link login lands later. When set, it is stored hashed.
  password: z.string().min(8).nullish(),
});
export type UserCreate = z.infer<typeof UserCreateSchema>;

export const UserUpdateSchema = z
  .object({
    name: z.string().min(1).nullish(),
    role: RoleSchema.optional(),
    isActive: z.boolean().optional(),
    password: z.string().min(8).nullish(),
  })
  .refine((o) => Object.values(o).some((v) => v !== undefined), { message: "no fields to update" });
export type UserUpdate = z.infer<typeof UserUpdateSchema>;

/** Friendly role labels for the admin UI. */
export const ROLE_LABELS: Record<Role, string> = {
  admin: "Admin / Recruiter",
  client_viewer: "Client viewer",
  restricted_viewer: "Restricted viewer",
};
